import { render, staticRenderFns } from "./Subcategories_Learner.vue?vue&type=template&id=f726a530&"
import script from "./Subcategories_Learner.vue?vue&type=script&lang=js&"
export * from "./Subcategories_Learner.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports